import React, { useState } from 'react';
import { useVotersStats } from '../hooks/useVoterState';
import { trimAddress } from '../hooks/constant';

export default function VotersInfo({ proposalId }) {
    const [pageId, setPageId] = useState(1);
    const voterStats = useVotersStats(proposalId, pageId);

    const handleNext = () => {
        if (voterStats.page < voterStats.totalPages) {
            setPageId(pageId + 1);
        }
    };

    const handlePrev = () => {
        if (pageId > 1) {
            setPageId(pageId - 1);
        }
    };

    return (
        <div className="row">
            <div className="col-12 col-md-8">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">
                            Votes({voterStats.voterList ? voterStats.voterList.length : 0})
                        </h4>
                        <div className="table-responsive ">
                            <table className="table table-dark table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>Address</th>
                                        <th>Vote</th>
                                        <th>Weightage</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {voterStats.voterList && voterStats.voterList.length > 0 ? (
                                        voterStats.voterList.map((items, key) => (
                                            <tr key={key}>
                                                <td>{trimAddress(items._user)}</td>
                                                <td>{items._voteValue}</td>
                                                <td>{items._voteWeight}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={3} className="text-center">
                                                No Record Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {/* Pagination buttons */}
                        <div className="d-flex justify-content-end">
                            <button
                                className="btn btn-secondary"
                                onClick={handlePrev}
                                disabled={pageId <= 1} // Disable if on the first page
                            >
                                Previous
                            </button>
                            <button
                                className="btn btn-secondary"
                                onClick={handleNext}
                                disabled={voterStats.page >= voterStats.totalPages} // Disable if on the last page
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
